var map = {
	"./404.svg": "Ja8s",
	"./Categories.png": "AWxf",
	"./Edit-menu.svg": "bMbg",
	"./Egg.svg": "+T+u",
	"./Emaier-Header.png": "UF4q",
	"./Qr-4.png": "jO93",
	"./_duplicate.svg": "OrT3",
	"./_overview.svg": "eOpb",
	"./add-white.svg": "azQY",
	"./alert.svg": "5VFA",
	"./archive.svg": "LSNn",
	"./armchair.svg": "CP42",
	"./arrow-circle-right.svg": "bn+M",
	"./arrow-left-circle.svg": "Cg3g",
	"./arrow-right-circle.svg": "bCM7",
	"./arrow-right.svg": "tjI2",
	"./asc-up-white.svg": "bH0z",
	"./asc.png": "gdDA",
	"./asc.svg": "D7sM",
	"./back-arrow.svg": "+16f",
	"./backupRestoreIcon.svg": "Ra4w",
	"./barcode-icon.svg": "ZrTy",
	"./beverages.svg": "Ephn",
	"./blue-edit-pen.svg": "3ZmZ",
	"./blue-eye.svg": "xPue",
	"./box-office.svg": "FIgG",
	"./broken-seat.jpg": "qBHG",
	"./calendar_list.svg": "16/i",
	"./chevron-down.svg": "Mhux",
	"./chevron-left.svg": "zRsH",
	"./cinema-mamagement-sidebar.svg": "aF4X",
	"./claendar.svg": "a7dd",
	"./clock-1.svg": "XPgk",
	"./clock.svg": "hVJM",
	"./close-button.svg": "PJmj",
	"./close-white.svg": "u12b",
	"./close-x.svg": "3/wO",
	"./collapse-up.svg": "0Q5H",
	"./collapse.svg": "pwQh",
	"./connection-lost.svg": "QNL+",
	"./copy.svg": "wbUR",
	"./copy_image_icon.png": "tHW+",
	"./delete-black.svg": "W3x5",
	"./delete-red-light.svg": "cxSZ",
	"./delete-red.svg": "kvFG",
	"./delete.svg": "2Taf",
	"./deliver-icon.svg": "OziZ",
	"./desc-down-white.svg": "6sbi",
	"./desc.svg": "gjTk",
	"./distributors-sidebar.svg": "L2Q8",
	"./download.svg": "BJPT",
	"./dragndrop.svg": "B1e2",
	"./dragndrop2.svg": "M3mC",
	"./duplicate.svg": "FayX",
	"./duplicateScreen.svg": "2wmU",
	"./e-wallet-icon-black.svg": "CzoI",
	"./edit-pen-blue.svg": "xkaK",
	"./edit-pen-white.svg": "Y6dB",
	"./edit-pen.svg": "ma+6",
	"./edit.svg": "KzyE",
	"./email.png": "S5ue",
	"./empty-folder.svg": "bJie",
	"./empty-image.svg": "5g8s",
	"./excel.svg": "hmIx",
	"./external-link.svg": "ALk7",
	"./eye.svg": "UuSx",
	"./filter-icon.svg": "GPX5",
	"./flag.svg": "WAD7",
	"./fnb-beverages.svg": "NDZ/",
	"./fnb-brownie.svg": "d2C0",
	"./fnb-combo.svg": "z4j6",
	"./fnb-desert.svg": "Qzpv",
	"./fnb-eatables.svg": "9O74",
	"./fnb-make-your-combo.svg": "cfwQ",
	"./fnb-popcorn.svg": "XPvm",
	"./fullscreen-icon.svg": "iEQX",
	"./funnel.svg": "8U4L",
	"./globe.svg": "8rL4",
	"./green-tick.svg": "i8Lv",
	"./grid-view.svg": "6hZN",
	"./hide-password.svg": "hwaq",
	"./home.svg": "cwHI",
	"./icon-black-play.svg": "ovub",
	"./icon-dot.svg": "a2kT",
	"./icon-fnb.svg": "PTdL",
	"./icon-marketing.svg": "8CWN",
	"./icon-no-seat.png": "bzuI",
	"./icon-no-seat.svg": "X2qp",
	"./icon-poin-of-sale.svg": "D59z",
	"./icon-recliner.svg": "vkga",
	"./icon-report.svg": "+KwZ",
	"./icon-sofa-dark-1.svg": "y7mH",
	"./icon-sofa-dark.png": "+ifK",
	"./icon-sofa-dark.svg": "hniS",
	"./icon-sofa.svg": "PYGs",
	"./icons8-website-analytics-64.svg": "yOHb",
	"./importfile.svg": "pjW+",
	"./info.svg": "5mtN",
	"./info2.svg": "WjyT",
	"./keyboard-icon.svg": "ZA/u",
	"./language-icon.svg": "Kqa7",
	"./left-caret.svg": "Nx+t",
	"./link.svg": "7e40",
	"./list-view.svg": "zRCF",
	"./loading.svg": "EkDN",
	"./lock.svg": "8nh3",
	"./login-password.png": "ab3B",
	"./login-user.png": "IAkX",
	"./logout.svg": "qybN",
	"./logoutBlack.svg": "vdCQ",
	"./logs-svgrepo-com.svg": "ZdAu",
	"./masters-sidebar.svg": "FYMb",
	"./minus.svg": "AJ0O",
	"./movie-rolling.svg": "g5fL",
	"./mulitSchedule.svg": "Dj7R",
	"./nav-plus.svg": "MeBo",
	"./no-image.svg": "qYK3",
	"./no-schedule.svg": "lp5M",
	"./non-veg-mark.png": "KhX7",
	"./non-veg-mark.svg": "0QGv",
	"./notification.svg": "h4rj",
	"./open-link-blue.svg": "2llj",
	"./openPlanned.svg": "m5Mm",
	"./overview.svg": "FlUy",
	"./overview2.svg": "6nwP",
	"./pdf-icon.svg": "66jE",
	"./pdf.svg": "xVG0",
	"./pickup-ticket-icon.svg": "NbEL",
	"./play.svg": "Jln1",
	"./plus.svg": "dOtZ",
	"./pointofsale-1.svg": "JGJV",
	"./pointofsale-2.svg": "K3W4",
	"./pointofsale.png": "Rhsg",
	"./portfolio.svg": "WNwj",
	"./pos-fnb-no-itmes.svg": "1flc",
	"./pos-refresh.svg": "cNOe",
	"./primary/chevron-down.svg": "qZxk",
	"./primary/download.svg": "R1Zb",
	"./primary/edit.svg": "1Qb7",
	"./primary/filter.svg": "HwYN",
	"./primary/printer.svg": "UKhj",
	"./print-icon.svg": "E7Tk",
	"./print.svg": "7f2f",
	"./question.svg": "p2YR",
	"./question1.svg": "QSus",
	"./question2.svg": "W3B4",
	"./question3.svg": "Ge8/",
	"./recliner-1.svg": "xsED",
	"./recliner.png": "4lMr",
	"./refund-icon.svg": "VdVy",
	"./reload-icon.svg": "NEBG",
	"./restore.svg": "EvQC",
	"./right-caret.svg": "7y8S",
	"./role-management-sidebar.svg": "5AUW",
	"./save.svg": "nSJp",
	"./schedule-icon.svg": "Xsvq",
	"./school-calendar.svg": "dnn0",
	"./search-global-white.svg": "gHkB",
	"./search-global.svg": "vhSr",
	"./search.svg": "ysJu",
	"./searchIcon.svg": "OoG1",
	"./seat-icon-2.svg": "pyka",
	"./seat-icon.svg": "XOKI",
	"./seat-icons/3-wheelChair.png": "/ntR",
	"./seat-icons/block_seat_new.png": "wEdk",
	"./seat-icons/broken-seat-1.svg": "ZVdf",
	"./seat-icons/broken-seat-2.svg": "j6kC",
	"./select-food.png": "wnRA",
	"./settings.svg": "yiTR",
	"./show-password.svg": "0Y3t",
	"./slider-triangle.svg": "i6VB",
	"./snack.svg": "REaX",
	"./sort.svg": "HnqJ",
	"./star-empty.svg": "r07G",
	"./star-fill.svg": "pGK4",
	"./success-tick.svg": "s3r7",
	"./suitcase.svg": "8533",
	"./swap.svg": "IXb2",
	"./tick-green-item.svg": "Xc+v",
	"./tick-green.svg": "veQ4",
	"./tick-yellow.svg": "qDSQ",
	"./ticket-icon.svg": "qLU1",
	"./trash.svg": "GRto",
	"./unpaid-reservation.svg": "B4CE",
	"./updown-white.svg": "aa/N",
	"./updown.svg": "BgiJ",
	"./user-attribute.svg": "PZUq",
	"./user-attributes.svg": "/ixo",
	"./user-female.svg": "f2Yn",
	"./user-male-white.svg": "HrOz",
	"./user-male.svg": "+a4u",
	"./user-profile.svg": "THzK",
	"./userProfile.png": "xkyi",
	"./veg-food-mark-white.png": "v/wC",
	"./veg-foog-mark-trans.png": "9KKz",
	"./view.png": "4/wA",
	"./view.svg": "/12a"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z8jd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = z8jd
// module chunks = 0